export const websiteData = [
  {
    id: 1,
    name: "Tailored Tails | Shareable Pet Profiles",
    link: "https://tailoredtails.netlify.app",
    github: "https://github.com/luce-code/TailoredTails",
    description: "Keep all of your pet's information in one place.  Store medical data, food preferences, likes & dislikes all in one profile that can be easily accessed at any time. Share this profile with any pet sitter when you go out of town, or share this profile with your vet.  Stay up to date with shots with an easy calendar that can be updated by you and your vet.",
    group: true,
    stack: "React.js | CSS | Express | MongoDB | API | Netlify"
  },
  {
    id: 2,
    name: "Marathon | Streaming Service",
    link: "https://watch-marathon.netlify.app/",
    github: "https://github.com/orgs/React-Royalty/repositories",
    description: "Browse through today's most popular movies and television shows. Choose from any genre, or just browse by a certain vibe. Marathon is a streaming service primarily cloned from Netflix.com. For legal reasons, we will only have trailers available for viewing. This project was pair programmed by myself and fellow Fullstack Academy alum Madilyn Webb.",
    group: true,
    stack: "React.js | SCSS | Express | PostgreSQL | API | Netlify | Render"
  },
  {
    id: 3,
    name: "Curse of Strahd: Plight of the Sunseekers",
    link: "https://sunseekers.drewford.dev",
    github: "https://github.com/SleazyCook/sunseekers",
    description: "Curse of Strahd is a popular campaign within the tabletop game Dungeons & Dragons. Plight of the Sunseekers is my take on Curse of Strahd with my friends that play across the country on the virtual game board offered by Roll20. This site contains my public notes for the game so far.",
    group: false,
    stack: "React.js | SCSS | Netlify"
  },
  {
    id: 4,
    name: "Cozy Cuddles | Adopt a Pet",
    link: "https://cozy-cuddles.drewford.dev",
    github: "https://github.com/SleazyCook/adoption",
    description: "Landing page for a fictional pet adoption agency. This project uses CSS Grid to create a fully responsive web application to market this agency including their services offered and values. Browse through available pets and get to know them by name, age, and breed. At the bottom of the web page, there is a beautiful form using custom radio buttons to submit an inquiry for adoption, volunterring, and more.",
    group: false,
    stack: "React.js | SCSS | Netlify"
  },
  {
    id: 5,
    name: "Zach and Drew Make Websites",
    link: "https://come-at-us.netlify.app",
    github: "https://github.com/orgs/Tired-Poor/repositories",
    description: "Pair Programming project with developer Zach Power to create a variety of front end project templates including portfolios, product landing pages, and more. This site serves as an outreach to potential freelance clients for a their unique and specific needs by showcasing a wide range of possibile webpages.",
    group: true,
    stack: "React.js | CSS | SCSS | Netlify"
  },
  {
    id: 6,
    name: "Natours | Nature Tours",
    link: "https://natours-by-drewford.netlify.app",
    github: "https://natours.drewford.dev",
    description: "Static site using only HTML and SASS originally created by Jonas Schedtmann for his Advanced CSS and SASS course for Udemy. Natours is a landing page for a fictional company that offers a variety of natours tours. Follow through a page a of various animations to see features, reviews, and book your first tour.",
    group: false,
    stack: "HTML | SASS | Netlify"
  },
  {
    id: 7,
    name: "trillo | Hotel Booking",
    link: "https://trillo-by-drewford.netlify.app",
    github: "https://github.com/SleazyCook/trillo",
    description:  "Static site using only HTML, SASS, and Flexbox originally created by Jonas Schedtmann for his Advanced CSS and SASS course for Udemy. trillo is a landing page for a fictional company that offers a variety of travel bookings. Follow through a page a of various animations to see features, reviews, and book your first trip.",
    group: false,
    stack: "HTML | SASS | Netlify"
  },
  {
    id: 8,
    name: "nexter | Your Own Home",
    link: "https://nexter-by-drewford.netlify.app",
    github: "https://github.com/SleazyCook/Nexter",
    description: "Static site using only HTML, SASS, and CSS Grid originally created by Jonas Schedtmann for his Advanced CSS and SASS course for Udemy. nexter is a landing page for a fictional company that offers a variety of international offers for real estate. Follow through a page a of various animations to see features, reviews, and find your own home.",
    group: false,
    stack: "HTML | SASS | Netlify"
  },
  {
    id: 9,
    name: "Poster Children | E-Commerce Web Application",
    link: "https://poster-children.netlify.app",
    github: "https://github.com/2209-Poster-Children",
    description: "Capstone Project from Fullstack Academy Bootcamp. Collaboration with a small group of cohorts to create a fictional, but functional E-Commerce website for buying posters from movies, musical artists, and videogames. Register and create an account. Add items to your cart and store addresses and credit card information for checkout. Leave reviews on shop items.",
    group: true,
    stack: "React.js | CSS | Express.js | PostgreSQL | API | Stripe | Netlify | Render"
  },
  {
    id: 10,
    name: "Dwayne's Travel Journal | D&D Companion",
    link: "https://dwayne.drewford.dev",
    github: "https://github.com/SleazyCook/dwayne-the-shell",
    description: "Player notes for a D&D campaign. Character is Dwayne the Shell Johnson, a small humanoid turtle merchant who moonlights as a mercenary. This site contains character art, notes from game sessions, and invtenory items. There is also a hidden backstory page.",
    group: false,
    stack: "React.js | SCSS | Netlify"
  },
  {
    id: 11,
    name: "Delavega Autoplex",
    link: "https://delavegaautoplex.netlify.app",
    github: "https://github.com/SleazyCook/autoplex",
    description: "Business site for car dealership in McAllen, TX. Learn about Delavega Autoplex's local history and inventory of cars, SUVs, and trucks. Read testimonials from verified purchasers, reach out directly to the owners, and manage your payments and payment history.",
    group: false,
    stack: "React.js | CSS | Express.js | PostgreSQL | API | Netlify"
  },
  {
    id: 12,
    name: "Drewford's List",
    link: "https://drewfordslist.netlify.app",
    github: "https://github.com/SleazyCook/project_05",
    description: "A school project experimenting with Front End fetch requests to create, read, update, and destroy data from a premade database.",
    group: false,
    stack: "React.js | CSS"
  }
]